<template>
    <div>
        <iframe
            id="iframe"
            ref="iframe"
            :srcdoc="nonTaxInfo"
            frameborder="0"
        ></iframe>
    </div>
</template>

<script>
export default {
    data () {
        return {
            nonTaxInfo: null,
        }
    },
    created () {
        const loading = this.$loading({
            lock: true,
            text: "正在跳转到支付页面，请稍后......",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0)",
            customClass: "extra-info-loading-icon",
        });
        let nonTaxInfo = sessionStorage.getItem("nonTaxInfo");
        this.nonTaxInfo = nonTaxInfo;
        this.$nextTick(() => {
            let iframe = document.getElementById("iframe");
            if (iframe.attachEvent) {
                iframe.attachEvent("onload", function () {
                    loading.close()
                });
            } else {
                iframe.onload = function () {
                    loading.close()
                };
            }
        })
    }
}
</script>

<style>
iframe {
    width: 100vw;
    height: 100vh;
}

.extra-info-loading-icon {
    font-size: 70px;
}

.extra-info-loading-icon .el-loading-text {
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pay/nonTax.vue